import { Divider, Field, Input, Select } from '@fluentui/react-components';
import { ActivityModel, ActivityView } from '@gkn-ili/views/dist/Activities';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { getValidationState } from './formValidation';
import { orderService } from '../../../utils/orderService';

function parseAsVector3(value: string): [number, number, number] {
  const components = value.split(';');
  if (components.length !== 3) {
    throw 'Should contain 3 components, splitted by ;';
  }
  const x = Number.parseFloat(components[0]);
  const y = Number.parseFloat(components[1]);
  const z = Number.parseFloat(components[2]);
  if (isNaN(x) || isNaN(y) || isNaN(z)) {
    throw 'These are not valid number';
  }
  return [x, y, z];
}

export type AppActivityConfigFormFields = {
  activity: {
    subjects: { ref: string[]; offsetPosition: string; showPartNumber: boolean }[];
    genericActivityKey: ActivityModel['genericActivityKey'];
  };
};

export function AppActivityConfigGetDefaultValues(activity: ActivityView): AppActivityConfigFormFields {
  return {
    activity: {
      subjects: activity.subjects.map((v) => ({
        ref: v.ref,
        offsetPosition: v.offsetPosition?.join(';') ?? '0;0;0',
        showPartNumber: v.showPartNumber ?? true,
      })),
      genericActivityKey: activity.genericActivityKey,
    },
  };
}

export function AppActivityConfigGetSaveData(
  data: AppActivityConfigFormFields,
): Pick<ActivityModel, 'count' | 'genericActivityKey' | 'subjects' | 'customAttributes'> {
  return {
    subjects: data.activity.subjects.map((subject) => ({
      ref: subject.ref,
      showPartNumber: subject.showPartNumber,
      offsetPosition: parseAsVector3(subject.offsetPosition),
    })),
    customAttributes: {},
    count: data.activity.subjects.length,
    genericActivityKey: data.activity.genericActivityKey,
  };
}

export default function AppActivityConfig() {
  const formHandlers = useFormContext<AppActivityConfigFormFields>();
  const availableGenericActivities = orderService.getAvailableGenericActivities();

  const visualsType = formHandlers.watch('activity.subjects');

  return (
    <>
      <Divider>Activity</Divider>
      <Field
        label="Category"
        orientation="horizontal"
        {...getValidationState('activity.genericActivityKey', formHandlers.formState.errors)}
      >
        <Select {...formHandlers.register('activity.genericActivityKey')}>
          {Object.entries(availableGenericActivities).map(([key]) => (
            <option key={key} value={key}>
              {key}
            </option>
          ))}
        </Select>
      </Field>
      <Field label="Number of objects" orientation="horizontal">
        <Input disabled value={visualsType.length.toLocaleString()} />
      </Field>
      {/* <Field
        label="Exploded offset position"
        orientation="horizontal"
        {...getValidationState('activity.offsetPosition', formHandlers.formState.errors)}
      >
        <Input
          value={offsetPositionValue}
          {...formHandlers.register('activity.offsetPosition', {
            validate: (value): ValidateResult => {
              const components = value.split(';');
              if (components.length !== 3) {
                return 'Should contain 3 components, splitted by ;';
              }
              const x = Number.parseFloat(components[0]);
              const y = Number.parseFloat(components[1]);
              const z = Number.parseFloat(components[2]);
              if (isNaN(x) || isNaN(y) || isNaN(z)) {
                return 'These are not valid number';
              }
              return true;
            },
          })}
          className={styles.field}
        />
      </Field>
      <Field label="Show part numbers" orientation="horizontal">
        <Switch checked={showPartNumberValue} {...formHandlers.register('activity.showPartNumber')} />
      </Field> */}
    </>
  );
}
